import {getLastDot} from '.';

export const getFileName = (name: string) => {
  const lastDot = getLastDot(name);
  return name.substring(0, lastDot);
};
